// PAGINATION
export const LIMIT_AMOUNT_OF_VIDEOS = 20;

// SELECT VIDEO MODAL
export const SELECT_MODAL_LIMIT_AMOUNT_OF_VIDEOS = 50;
